module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('glogo'), _vm._v(" "), _c('grednav', {
    attrs: {
      "type": "home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row-login carousel slide",
    attrs: {
      "id": "carousel-generic",
      "data-ride": "carousel"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-width set-position"
  }, [_c('div', {
    staticClass: "log-in"
  }, [_c('div', [_c('p', [_vm._v("你好，欢迎来到南方水泥！")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.cashome
    }
  }, [_c('button', {
    staticClass: "form-control btn btn-login action"
  }, [_vm._v("立即登录")])]), _vm._v(" "), _c('a', {
    staticClass: "form-control btn btn-default btn-apply",
    attrs: {
      "href": "agreement.html?register",
      "target": "_blank"
    }
  }, [_vm._v("供应商注册")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.enterlink
    }
  }, [_vm._v("还没有账号?")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "row-content"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    staticClass: "bid-info pull-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('infotable', {
    staticClass: "table-latest",
    attrs: {
      "tableTitle": _vm.tableTitle[0],
      "tableContent": _vm.tableContent['latest'],
      "which": _vm.tableType[0]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('infotable', {
    staticClass: "table-area",
    attrs: {
      "datatype": "area",
      "tableTitle": _vm.tableTitle[1],
      "tableContent": _vm.tableContent['area'],
      "which": _vm.tableType[1]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('infotable', {
    staticClass: "table-type",
    attrs: {
      "datatype": "type",
      "tableTitle": _vm.tableTitle[2],
      "tableContent": _vm.tableContent['type'],
      "which": _vm.tableType[2]
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bid-notice pull-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('notice', {
    attrs: {
      "type": "bidding",
      "apiUrl": _vm.noticeUrl[1],
      "num": 2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('notice', {
    attrs: {
      "type": "company",
      "apiUrl": _vm.noticeUrl[0],
      "ajaxType": 'get'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('notice', {
    attrs: {
      "type": "clarify"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('notice', {
    attrs: {
      "type": "links",
      "id": "notice-links"
    }
  })], 1)])])]), _vm._v(" "), _c('regflows'), _vm._v(" "), _c('gsupplier'), _vm._v(" "), _c('gfooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#carousel-generic",
      "data-slide-to": "0"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carousel-generic",
      "data-slide-to": "1"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carousel-generic",
      "data-slide-to": "2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "19px"
    }
  }, [_c('h5', [_c('img', {
    attrs: {
      "src": "static/imgs/helpCenter.png",
      "alt": ""
    }
  }), _vm._v(" 帮助中心")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "manual.html",
      "target": "_blank"
    }
  }, [_vm._v("供应商操作手册")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("供应商注册视频")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox",
      "id": "getOnfocus"
    }
  }, [_c('div', {
    staticClass: "item active"
  }, [_c('div', {
    staticClass: "carousel-bg carousel-bg1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "carousel-bg carousel-bg2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "carousel-bg carousel-bg3"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41c4b372!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/home.vue
// module id = 264
// module chunks = 9